import { render, staticRenderFns } from "./recharge_side.vue?vue&type=template&id=55b63ac0&scoped=true"
import script from "./recharge_side.vue?vue&type=script&lang=js"
export * from "./recharge_side.vue?vue&type=script&lang=js"
import style0 from "./recharge_side.vue?vue&type=style&index=0&id=55b63ac0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b63ac0",
  null
  
)

export default component.exports